<template>
  <div class="tipsign">
		<div class="tipCar">
			<div class="tipleft">
				
			</div>
			<span>{{titleName}}</span>
		</div>

  </div>
</template>

<script>

export default {
  components: {

  },
 
  props: ['titleName'],
  data() {
		return {

			
		};
  },
  
  onLoad() {
	
  },
  
  methods: {
	  
  }
};
</script>

<style scoped lang="scss">
	.tipsign{
		.tipCar{
			height: 0.4rem;
			line-height: 0.4rem;
			display: flex;
			align-items: center;
			font-size: 0.16rem;
			color: #E70012;
			.tipleft{
				width: 0.05rem;
				height: 0.13rem;
				background: #E70012;
				margin-right: 0.1rem;
			}
		}
		
		
	}
	
</style>
